export const faqs = [
  {
    id: 1,
    question: "What changed with the Income Tax Act 2025 from April 2026?",
    answer: "India's new Income Tax Act 2025 replaces the 1961 law effective April 1, 2026. It introduces the 'Tax Year' concept (replacing FY/AY), reduces sections from 800+ to 536, makes the new tax regime default, and simplifies compliance language. Form 130 replaces Form 16."
  },
  {
    id: 2,
    question: "What is the 'Tax Year' concept in the new Income Tax Act?",
    answer: "The Tax Year replaces both Financial Year and Assessment Year. Income earned from April 1 to March 31 is now reported and taxed within the same 'Tax Year' — eliminating the confusing FY/AY distinction and aligning India with global tax practices."
  },
  {
    id: 3,
    question: "What are the income tax slabs under the new regime for Tax Year 2026-27?",
    answer: "New regime (default): Nil up to Rs. 4 lakh, 5% (Rs. 4-8L), 10% (Rs. 8-12L), 15% (Rs. 12-16L), 20% (Rs. 16-20L), 25% (Rs. 20-24L), 30% (above Rs. 24L). Zero tax up to Rs. 12 lakh with Section 87A rebate of Rs. 60,000. Standard deduction Rs. 75,000."
  },
  {
    id: 4,
    question: "How have TDS sections changed under the new Act?",
    answer: "TDS on salary moves to Section 392. All other TDS provisions consolidate under Section 393(c). New Section 194T applies TDS on partner payments above Rs. 20,000. TCS categories rationalized to uniform 2% under Section 394. Section numbering changed but rates are largely unchanged."
  },
  {
    id: 5,
    question: "What services does AS Consultech provide?",
    answer: "AS Consultech provides end-to-end compliance including Income Tax & GST filing, ROC compliance, cloud accounting, financial reporting (MIS), business consulting, and company formation — serving as your single strategic compliance and growth partner across India."
  },
  {
    id: 6,
    question: "How is AS Consultech different from a regular CA firm?",
    answer: "Unlike traditional CA firms focused on return filing, we build complete business systems — combining regulatory expertise with cloud accounting, automated workflows, real-time dashboards, and strategic advisory aligned with the new Income Tax Act 2025 and GST 2.0 frameworks."
  },
  {
    id: 7,
    question: "Is e-invoicing mandatory for my business from April 2026?",
    answer: "Yes, if your aggregate annual turnover exceeds Rs. 5 crore. Businesses above Rs. 10 crore have a 30-day IRP reporting limit — late invoices will be invalid for ITC claims. New invoice series and LUT filing are required for FY 2026-27."
  },
  {
    id: 8,
    question: "What MSME compliance changes apply from 2026?",
    answer: "Key changes: payment delays to MSME vendors now trigger income tax disallowance, auto-approved registrations for low-ITC MSMEs, mandatory bank verification on GST portal, trust-based penalty model under Finance Bill 2026, and enhanced credit guarantee schemes."
  },
  {
    id: 9,
    question: "Do you handle GST registration and filing?",
    answer: "Yes. We manage the full GST lifecycle — registration, monthly/quarterly returns (GSTR-1, GSTR-3B), annual returns (GSTR-9), ITC reconciliation, e-invoicing compliance, and GST audit support for businesses across India, fully aligned with 2026 GST reforms."
  },
  {
    id: 10,
    question: "Can you help with company incorporation?",
    answer: "Yes. We handle complete incorporation for Private Limited Companies, LLPs, OPCs, and Partnership Firms — including name approval, DSC/DIN, documentation, ROC filing, and all statutory registrations post-incorporation under the latest MCA guidelines."
  },
  {
    id: 11,
    question: "What technology tools do you use?",
    answer: "We use cloud platforms like Tally Prime, Zoho Books, and QuickBooks, with automated workflows for compliance tracking, digital document management, and real-time financial reporting dashboards — ensuring seamless adoption of digital compliance under the new Act."
  },
  {
    id: 12,
    question: "Can you help respond to Income Tax or GST notices?",
    answer: "Absolutely. Our team handles scrutiny assessments, demand notices, and show-cause notices — preparing detailed responses, representing before authorities, and resolving issues efficiently under both the old Act (for past years) and the new Income Tax Act 2025."
  },
  {
    id: 13,
    question: "What is your approach to tax planning under the new regime?",
    answer: "We take a proactive approach — analyzing whether old or new regime benefits you more, identifying legitimate deductions and exemptions, and structuring your tax strategy for the full Tax Year. The new regime is default but opting out is possible with proper planning."
  },
  {
    id: 14,
    question: "Do you serve businesses outside Tamil Nadu?",
    answer: "Yes. While headquartered in Dindigul, Tamil Nadu, our cloud-based systems and digital-first approach enable us to serve businesses across all Indian states seamlessly. Many clients operate multi-state with GST registrations in multiple jurisdictions."
  },
  {
    id: 15,
    question: "What is the cost of your services?",
    answer: "Pricing is customized based on business size, complexity, and service scope. We offer monthly retainers, annual packages, and project-based engagements. Book a free consultation for a personalized, no-obligation quote."
  },
  {
    id: 16,
    question: "What is Form 130 and when does it replace Form 16?",
    answer: "Form 130 is the new TDS certificate under the Income Tax Act 2025, replacing Form 16 for salary TDS. Similarly, Form 124 replaces Form 12BB for investment declarations, and Form 157 is required for Indians leaving the country. These changes apply from Tax Year 2026-27."
  }
];
